import React, { useState } from "react";
import { colorForId, initials } from "@/lib/constants";
import { API } from "@/lib/api";

export default function Avatar({ id, name, size = 26, className = "", version }) {
  const [ok, setOk] = useState(true);
  const s = { width: size, height: size, background: colorForId(id), fontSize: size * 0.4 };
  if (ok && id) {
    return (
      <img
        src={`${API}/avatars/${id}${version ? `?v=${version}` : ""}`}
        alt={name}
        title={name}
        onError={() => setOk(false)}
        style={{ width: size, height: size }}
        className={`inline-block rounded-full object-cover shrink-0 ${className}`}
      />
    );
  }
  return (
    <span
      title={name}
      style={s}
      className={`inline-flex items-center justify-center rounded-full text-white font-semibold shrink-0 ${className}`}
    >
      {initials(name)}
    </span>
  );
}
